/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EcosystemFeaturedDetailInfo } from '../models/EcosystemFeaturedDetailInfo';
import type { EcosystemGeneralInfo } from '../models/EcosystemGeneralInfo';
import type { EcosystemProjectDetailInfo } from '../models/EcosystemProjectDetailInfo';
import type { LlamaChartInfo } from '../models/LlamaChartInfo';
import type { ProjectCategoryInfo } from '../models/ProjectCategoryInfo';
import type { ProjectSortInfo } from '../models/ProjectSortInfo';
import type { ProjectSummaryListInfo } from '../models/ProjectSummaryListInfo';
import type { ProtocolCategoryListInfo } from '../models/ProtocolCategoryListInfo';
import type { ProtocolListInfo } from '../models/ProtocolListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EcosystemControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns ProjectSummaryListInfo OK
     * @throws ApiError
     */
    public getEcosystemProjectSearch({
        term = '',
        category = 'ALL',
        sort = 'RECENT',
        page = 1,
        size = 12,
    }: {
        term?: string,
        category?: 'ALL' | 'AI' | 'ARTICLE' | 'ADVERTISING' | 'APPLICATION_DEVELOPMENT' | 'CENTRALIZED_EXCHANGE' | 'COLLECTIBLES_PLATFORM' | 'CONTENT_CREATION_AND_DISTRIBUTION' | 'CROSS_CHAIN_SERVICE' | 'CROWDFUNDING' | 'DATA' | 'DECENTRALIZED_EXCHANGE' | 'DEFI_ASSET_MANAGEMENT' | 'DEFI_DERIVATIVES' | 'DEFI_INSURANCE' | 'DEFI_LENDING_BORROWING' | 'DEFI_OTHER' | 'ENERGY' | 'ENTERPRISE_AND_BAAS' | 'FILE_STORAGE' | 'GAMBLING' | 'GAMING' | 'HEALTHCARE' | 'IDENTITY' | 'INFRASTRUCTURE' | 'IOT' | 'INTEROPERABILITY_PLATFORM' | 'LAUNCHPAD_SERVICE' | 'MAINNET' | 'MEMES' | 'ORACLE_SERVICE' | 'P2E' | 'PAYMENT_PLATFORM' | 'PRIVACY_FOCUS' | 'PREDICTION_MARKETS' | 'REWARDS_SERVICE' | 'SCALING_SOLUTION' | 'SECURITY' | 'SHARED_COMPUTE' | 'SMART_CONTRACT_PLATFORM' | 'SOCIAL_MEDIA' | 'STABLECOIN' | 'STO_PLATFORM' | 'SUPPLY_CHAIN' | 'VIRTUAL_AND_AUGMENTED_REALITY' | 'WALLET_SERVICE' | 'WRAPPED_TOKEN' | 'NFT' | 'ENTERTAINMENT' | 'METAVERSE' | 'FAN_TOKEN',
        sort?: 'RECENT' | 'ALPHABETICAL',
        page?: number,
        size?: number,
    }): CancelablePromise<ProjectSummaryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ecosystem/search',
            query: {
                'term': term,
                'category': category,
                'sort': sort,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns ProtocolListInfo OK
     * @throws ApiError
     */
    public getProtocolList({
        search = '',
        category = '',
        field = 'TVL',
        direction = 'DESC',
        page = 1,
        size = 1000,
    }: {
        search?: string,
        category?: string,
        field?: 'TVL' | 'D1' | 'D7' | 'M1',
        direction?: 'ASC' | 'DESC',
        page?: number,
        size?: number,
    }): CancelablePromise<ProtocolListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ecosystem/protocol/list',
            query: {
                'search': search,
                'category': category,
                'field': field,
                'direction': direction,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns ProtocolCategoryListInfo OK
     * @throws ApiError
     */
    public getProtocolCategoryList(): CancelablePromise<ProtocolCategoryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ecosystem/protocol/category/list',
        });
    }

    /**
     * @returns EcosystemProjectDetailInfo OK
     * @throws ApiError
     */
    public getEcosystemProjectDetail({
        id,
    }: {
        id: string,
    }): CancelablePromise<EcosystemProjectDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ecosystem/project',
            query: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProjectSortInfo OK
     * @throws ApiError
     */
    public getEcosystemProjectSortList(): CancelablePromise<Array<ProjectSortInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ecosystem/project/sort/list',
        });
    }

    /**
     * @returns EcosystemFeaturedDetailInfo OK
     * @throws ApiError
     */
    public getEcosystemFeatured({
        id,
        featuredId,
    }: {
        id: string,
        featuredId: string,
    }): CancelablePromise<EcosystemFeaturedDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ecosystem/project/featured',
            query: {
                'id': id,
                'featuredId': featuredId,
            },
        });
    }

    /**
     * @returns ProjectCategoryInfo OK
     * @throws ApiError
     */
    public getEcosystemProjectCategoryList(): CancelablePromise<Array<ProjectCategoryInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ecosystem/project/category/list',
        });
    }

    /**
     * @returns EcosystemGeneralInfo OK
     * @throws ApiError
     */
    public getEcosystemGeneral({
        types,
    }: {
        types: string,
    }): CancelablePromise<EcosystemGeneralInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ecosystem/general',
            query: {
                'types': types,
            },
        });
    }

    /**
     * @returns LlamaChartInfo OK
     * @throws ApiError
     */
    public getTvlChartList(): CancelablePromise<LlamaChartInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ecosystem/chart/tvl',
        });
    }

}
